<template>
  <div 
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <div class="row mx-auto">
      <div class="col-md-4 mt-2 mx-auto">
        <form v-on:submit.prevent="register">
          <h1 class="h3 mb-3 font-weight-normal">Regisztrálás</h1>
          <div class="form-group">
            <label for="userType">Felhasználó típus</label>
            <select type="text" v-model="userTypeSelect" class="form-control" name="userType" placeholder="" required>
              <option v-for="user in userTypes" :key="user.id">
                {{ user }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="last_name">Vezetéknév</label>
            <input type="text" v-model="last_name" class="form-control" name="last_name" placeholder="" required>
          </div>
          <div class="form-group">
            <label for="first_name">Keresztnév</label>
            <input type="text" v-model="first_name" class="form-control" name="first_name" placeholder="" required>
          </div>
          <div class="form-group">
            <label for="monogram">Monogram</label>
            <input type="text" v-model="monogram" class="form-control" name="monogram" placeholder="" required>
          </div>
          <div class="form-group">
            <label for="email">Email cím</label>
            <input type="email" v-model="email" class="form-control" name="email" placeholder="" required>
          </div>

          <div id="app2" class="form-group">
            <label for="email">Jelszó</label>
            <div class="input_container">
              <input type="password" @input="p_len" v-model="password" placeholder="" >
              <span v-bind:class="{ valid_password_length: valid_password_length , show_password_length: typed}" class="password_length">{{password_length}}</span>
            </div>
            <div class="lnu_container">
              <p v-bind:class="{ lovercase_valid: contains_lovercase }">Kisbetű</p>
              <p v-bind:class="{ number_valid: contains_number }">Szám</p>
              <p v-bind:class="{ uppercase_valid: contains_uppercase }">Nagybetű</p>
            </div>
            <div class="valid_password_container" v-bind:class="{show_valid_password_container : valid_password }">
              <svg width="100%" height="100%" viewBox="0 0 140 100">
              <path class="tick" v-bind:class="{checked: valid_password }" 
                    d="M10,50 l25,40 l95,-70" />
            </svg>
            </div>
          </div>

          <button type="submit" class="btn btn-lg btn-primary btn-block">Regisztrálás!</button>
        </form>
      </div>

      <div class="col-md-8 mt-2 mx-auto">
        <h1 class="h3 mb-3 font-weight-normal">Felhasználók</h1>
        <b-table small striped hover :items="list" :fields="fields" :key="list.id">

          <!-- // EDIT -->
          <template v-slot:cell(edit)="row">
          <b-button
            size="sm"
            variant="primary"
            @click="$router.push({
                      name: 'UserNew',
                      params: { email: row.item.email}
                    })"
            ><b-icon-pencil></b-icon-pencil>
          </b-button>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>

    </div>
        
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      password_length: 0,
      typed: false,
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      valid_password_length: false,
      valid_password: false,

      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      first_name: '',
      last_name: '',
      monogram: '',
      email: '',
      password: null,
      userTypeSelect: '',
      userTypes: [
        'user',
        'admin'
      ],
      list: [],
      fields: [
        { key: 'id', label: 'Id', sortable: true, sortDirection: 'asc'},
        { key: 'first_name', label: 'Keresztné', sortable: true, sortDirection: 'asc'},
        { key: 'last_name', label: 'Vezetéknév', sortable: true, sortDirection: 'asc'},
        { key: 'monogram', label: 'Monogram', sortable: true, sortDirection: 'asc'},
        { key: 'email', label: 'Email', sortable: true, sortDirection: 'asc'},
        { key: 'usertype', label: 'Jogosultság', sortable: true, sortDirection: 'asc'},
        { key: 'edit', sortable: true },
        { key: 'del', sortable: true }
      ]

    }
  },

  methods: {
    p_len: function() {
      this.password_length = this.password.length;
      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }

      if (this.password_length > 0) {
        this.typed = true;
      } else {
        this.typed = false;
      }

      this.contains_lovercase = /[a-z]/.test(this.password);
      this.contains_number = /\d/.test(this.password);
      this.contains_uppercase = /[A-Z]/.test(this.password);

      // Check if the password is valid
      if (this.contains_lovercase == true && this.contains_number == true) {
        this.valid_password = false;
        if (
          this.contains_uppercase == true &&
          this.valid_password_length == true
        )
          this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },    
    register () {
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        if(    
          this.contains_lovercase == true && 
          this.contains_number == true && 
          this.contains_uppercase == true &&
          this.typed == true &&
          this.valid_password_length == true &&
          this.valid_password == true 
          ) {
          axios.post(process.env.ROOT_API+'/users/register',
          {
            first_name: this.first_name,
            last_name: this.last_name,
            monogram: this.monogram,
            email: this.email,
            password: this.password,
            userType : this.userTypeSelect,
            token: this.token
          }
          ).then((res) => {
            this.loadList()
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post(process.env.ROOT_API+'/users/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (reqData) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Biztos, hogy törölni akarod? ', {
          title: 'Megerősítés',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(reqData)
        })
        .catch(err => {
          console.log(err)
        })
    },    
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post(process.env.ROOT_API+'/users/getlist', { payload })
          .then(res => {
            this.list = res.data
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue